import React from 'react';
import { Copy, ExternalLink, Download, Play } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip';
import { useTraceSidebar } from '@/contexts/TraceSidebarContext';

interface TraceActionsProps {
  trajectoryId?: string;
}

export function TraceActions({ trajectoryId }: TraceActionsProps) {
  const { state } = useTraceSidebar();

  const handleCopyId = async () => {
    if (state.selectedTraceId) {
      await navigator.clipboard.writeText(state.selectedTraceId);
    }
  };

  const handleCopyTrajectoryId = async () => {
    if (trajectoryId) {
      await navigator.clipboard.writeText(trajectoryId);
    }
  };

  const handleExport = () => {
    // TODO: Implement export functionality
    console.log('Export trace data');
  };

  const handleOpenPlayground = () => {
    // TODO: Implement playground functionality
    console.log('Open in playground');
  };

  return (
    <TooltipProvider>
      <div className="flex items-center justify-between p-2 border-t bg-card">
        <div className="flex items-center gap-1">
          {trajectoryId && (
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="ghost"
                  size="sm"
                  className="h-7 text-xs"
                  onClick={handleCopyTrajectoryId}
                >
                  <Copy className="h-3 w-3 mr-1" />
                  ID
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                <p>Copy trajectory ID</p>
              </TooltipContent>
            </Tooltip>
          )}

          {state.selectedTraceId && (
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="ghost"
                  size="sm"
                  className="h-7 text-xs"
                  onClick={handleCopyId}
                >
                  <Copy className="h-3 w-3 mr-1" />
                  Step ID
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                <p>Copy step ID</p>
              </TooltipContent>
            </Tooltip>
          )}
        </div>

        <div className="flex items-center gap-1">
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                className="h-7 w-7"
                onClick={handleExport}
              >
                <Download className="h-3.5 w-3.5" />
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <p>Export trace data</p>
            </TooltipContent>
          </Tooltip>

          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                className="h-7 w-7"
                onClick={handleOpenPlayground}
              >
                <Play className="h-3.5 w-3.5" />
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <p>Open in Playground</p>
            </TooltipContent>
          </Tooltip>

          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                className="h-7 w-7"
                onClick={() => window.open(window.location.href, '_blank')}
              >
                <ExternalLink className="h-3.5 w-3.5" />
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <p>Open in new tab</p>
            </TooltipContent>
          </Tooltip>
        </div>
      </div>
    </TooltipProvider>
  );
}

export default TraceActions;
